export default {
  name: 'ScFriendlyHero',
  props: {
    heading: {
      type: String,
      default: '',
    },
    subheading: {
      type: String,
      default: '',
    },
  },
  computed: {
    showHeading() {
      return this.heading && this.heading.length > 0;
    },
    showSubheading() {
      return this.subheading && this.subheading.length > 0;
    },
  },
};
